<template>
  <div class="counterparty-main-info">
    <div class="counterparty-header">
      <h3 class="header-title">Основная информация</h3>
      <div class="header-actions">
        <base-button
          class="header-btn"
          v-if="!editingCounterpartyInfo"
          :disabled="loading"
          @click="$emit('start-edit')"
        >
          Редактировать
        </base-button>
        <base-button
          class="header-btn"
          type="button"
          :disabled="loading"
          @click="$emit('toggleStatus')"
        >
          {{ counterparty.enabled ? "Отключить" : "Включить" }}
        </base-button>
      </div>
    </div>

    <div class="info-columns">
      <div class="info-column">
        <BaseInfoCard title="Общие данные">
          <BaseInfoField label="Статус:" inline-on-wide>
            <span
              class="status-text"
              :class="counterparty.enabled ? 'status-active' : 'status-inactive'"
            >
              {{ counterparty.enabled ? "Активен" : "Отключён" }}
            </span>
          </BaseInfoField>
          <BaseInfoField
            v-if="counterparty.source_type"
            label="Источник:"
            inline-on-wide
          >
            <span
              class="source-type-badge"
              :class="`source-type--${counterparty.source_type}`"
            >
              {{ sourceTypeLabel(counterparty.source_type) }}
            </span>
          </BaseInfoField>
          <BaseInfoField
            label="Название:"
            :value="counterparty.name"
            info-key="counterparty.common"
            inline-on-wide
          />
          <BaseInfoField
            label="ИНН:"
            :value="counterparty.inn"
            info-key="counterparty.common"
            inline-on-wide
          />
          <BaseInfoField
            label="КПП:"
            :value="counterparty.kpp"
            info-key="counterparty.common"
            inline-on-wide
          />
        </BaseInfoCard>

        <BaseInfoCard title="Адрес">
          <BaseInfoField
            label="Юридический адрес:"
            :value="counterparty.legal_address"
            info-key="counterparty.address"
            inline-on-wide
          />
          <BaseInfoField
            label="Почтовый адрес:"
            :value="counterparty.postal_address"
            info-key="counterparty.address"
            inline-on-wide
          />
          <BaseInfoField
            label="Город:"
            :value="counterparty.city"
            info-key="counterparty.address"
            inline-on-wide
          />
          <BaseInfoField
            label="Улица:"
            :value="counterparty.street"
            info-key="counterparty.address"
            inline-on-wide
          />
          <BaseInfoField
            label="Дом:"
            :value="counterparty.house"
            info-key="counterparty.address"
            inline-on-wide
          />
          <BaseInfoField
            label="Индекс:"
            :value="counterparty.postal_code"
            info-key="counterparty.address"
            inline-on-wide
          />
          <BaseInfoField
            label="Код региона:"
            :value="counterparty.region_code"
            info-key="counterparty.address"
            inline-on-wide
          />
        </BaseInfoCard>
      </div>

      <div class="info-column">
        <BaseInfoCard title="Контактные данные">
          <BaseInfoField
            label="Телефон:"
            :value="counterparty.phone"
            info-key="counterparty.common"
            inline-on-wide
          />
          <BaseInfoField
            label="Email:"
            :value="counterparty.email"
            inline-on-wide
          />
        </BaseInfoCard>

        <BaseInfoCard title="Реквизиты">
          <BaseInfoField label="Банк:" :value="counterparty.bank_name" inline-on-wide />
          <BaseInfoField label="БИК:" :value="counterparty.bik" inline-on-wide />
          <BaseInfoField
            label="Расчётный счёт:"
            :value="counterparty.account_number"
            inline-on-wide
          />
          <BaseInfoField
            label="Корр. счёт:"
            :value="counterparty.correspondent_account"
            inline-on-wide
          />
        </BaseInfoCard>
      </div>
    </div>

    <div
      class="meta-section"
      v-if="counterparty.created_at || counterparty.updated_at"
    >
      <MetaTime
        :createdAt="counterparty.created_at"
        :updatedAt="counterparty.updated_at"
      />
    </div>
  </div>
</template>

<script>
import MetaTime from "@/components/Meta/MetaTime.vue";

export default {
  name: "CounterpartyMainInfo",
  components: { MetaTime },
  props: {
    counterparty: { type: Object, required: true },
    editingCounterpartyInfo: { type: Boolean, required: true },
    loading: { type: Boolean, required: true },
  },
  methods: {
    sourceTypeLabel(type) {
      const labels = {
        manual: "Создан вручную",
        bank_statement: "Импортирован из банковских выписок",
      };
      return labels[type] || type;
    },
  },
};
</script>

<style scoped>
.counterparty-main-info {
  width: 100%;
}

.counterparty-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--base-in-indent);
}

.header-actions {
  display: flex;
  gap: 15px;
}

.info-columns {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--base-in-indent);
  align-items: start;
}

.info-column {
  display: flex;
  flex-direction: column;
  gap: var(--base-in-indent);
}

.status-text {
  display: inline-block;
  padding: 4px 14px;
  border-radius: 20px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}

.status-active {
  background-color: #16a34a;
}

.status-inactive {
  background-color: #dc2626;
}

.source-type-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
}

.source-type--manual {
  background: #dbeafe;
  color: var(--color-blue);
}

.source-type--bank_statement {
  background-color: #d1fae5;
  color: #059669;
}

.meta-section {
  margin-top: var(--base-in-indent);
}

@media (max-width: 768px) {
  .info-columns {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .counterparty-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
}

@media (max-width: 480px) {
  .status-text {
    padding: 3px 10px;
    font-size: 11px;
  }
}
</style>
